import { createSlice } from '@reduxjs/toolkit';

export type FormView = 'FORM' | 'REPORT';

interface FormToggleInterface {
  selected: FormView;
}

const initialState: FormToggleInterface = {
  selected: 'FORM',
};

const formToggleSlice = createSlice({
  name: 'formToggle',
  initialState,
  reducers: {
    setFormToggle: (state, action) => {
      state.selected = action.payload;
    },
  },
});

export const { setFormToggle } = formToggleSlice.actions;

export default formToggleSlice.reducer;

/** ===== Selectors ===== */
// If you have a typed RootState, use it. Otherwise keep `any`.
export const selectFormView = (s: any): FormView =>
  s.formToggle?.selected ?? 'FORM';
